module.exports = __webpack_public_path__ + "static/media/industries-wood-s.e9a331e1.webp";